import { render, staticRenderFns } from "./stampDialog.vue?vue&type=template&id=2b9ba6b6&"
import script from "./stampDialog.vue?vue&type=script&lang=ts&"
export * from "./stampDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports